import { useEffect } from 'react';
import { useGlobalToast } from './hooks';
import { setGlobalToastApi } from './utils';

export const GlobalToastInitializer: React.FC = () => {
  const toastRef = useGlobalToast();

  useEffect(() => {
    if (toastRef.current) {
      setGlobalToastApi({ show: toastRef.current.show, remove: toastRef.current.remove });
    }
  }, [toastRef]);

  return null;
};
